//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Paper from '@/components/ui/Paper'
import TaskForm from '@/components/tasks/TaskForm'
import SeoMethods from '@/mixins/SeoMethods'
import Pageview from '@/mixins/Pageview'

export default {
  name: 'CreateTaskPage',
  components: {
    Paper,
    TaskForm
  },
  mixins: [SeoMethods, Pageview],
  middleware: ['redirectClient', 'checkProfileCompleteness'],
  auth: false,
  head () {
    return this.buildTags(this.$t('meta.createTaskTitle'), this.$t('meta.createTaskDescription'))
  },
  computed: {
    /**
     * Checks if current user is logged in
     */
    isLoggedIn () {
      return this.$auth.loggedIn
    }
  },
  methods: {
    /**
     * When task created set it to prop and go to next step
     * @param task
     */
    async taskCreated (task) {
      if (this.isLoggedIn) {
        await this.$router.push(this.localePath('/create-task/subscription'))
      } else {
        await this.$router.push(this.localePath('/create-task/success'))
      }
    }
  }
}
